import React, { useEffect } from "react";
import { Box } from "rebass";
import Project from "./Project";
import imgCover1 from "../img/book.png";
import imgCover2 from "../img/book.png";
import imgCover3 from "../img/book.png";
import styled from "styled-components";

import "../flickity.css";
import Flickity from "react-flickity-component";

const flickityOptions = {
  initialIndex: 1,
  pageDots: false,
  fullscreen: true,
  freeScroll: true,
  contain: true,
  draggable: false,
  wrapAround: false,
  //prevNextButtons: false,
  arrowShape: 'M78.1,48.2L51.8,23.9l-5.4,6.5c8.8,7.7,19.4,13.6,26.4,17.5l-0.2,0.5c-9.2-1-23.2-2.1-34.8-2.1H21.9v7.3h15.9 c11.6,0,25.6-0.9,34.8-1.8l0.2,0.5c-7.1,3.9-17.6,9.6-26.4,17.3l5.4,6.5l26.3-24.3V48.2z'
};

const projects = [
  {
    number: "01",
    title: "BOSE",
    tagline: "Setting the foundations for an immersive shopping experience.",
    desc: "Second desc",
    discipline: "DS/UI/FE",
    url: imgCover3,
    id: "4",
    page: "/bose/",
    year: "2018",
    label: "New"
  },
  {
    number: "02",
    title: "DESIGN SYSTEM(s)",
    tagline: "Scaleable systematic approach to build-in visual consistency. Informed by OOUX.",
    desc: "First desc",
    discipline: "UI/FE",
    url: imgCover1,
    id: "1",
    page: "/design-system/",
    year: "2019 - 2020",
    label: ""
  },
  {
    number: "03",
    title: "eCOMMERCE",
    tagline: "Headless eCommerce Platform for Multi-Brands. Build on Gatsby.",
    desc: "Second desc",
    discipline: "DS/UI/FE",
    url: imgCover3,
    id: "3",
    page: "/ecom-platform/",
    year: "2018",
    label: ""
  },
  {
    number: "04",
    title: "LAPIERRE",
    tagline: "Design System applied, from brand book to a complete shopping experience.",
    desc: "Second desc",
    discipline: "UI/DS/FE",
    url: imgCover2,
    id: "2",
    page: "/lapierre/",
    year: "2020 - 2021",
    label: ""
  },
];

 const ProjectsListing = () => {
    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
    return (
      <StyledSection className="carousel-nav">
        <Box variant="containerHeader">
        <Flickity
          className={"carouselNav"}
          options={flickityOptions} // takes flickity options {}
          reloadOnUpdate
        >
          {/* Project list */}
          {projects.map((project, index) => (
            <Project
              url={project.url}
              tagline={project.tagline}
              number={project.number}
              page={project.page}
              title={project.title}
              discipline={project.discipline}
              year={project.year}
              id={project.id}
              label={project.label}
              key={project.id.toString()}
              index={index}
            />
          ))}
        </Flickity>
        </Box>
      </StyledSection>
    );
  }

const StyledSection = styled.section`
  position: relative;
  z-index: 2;
  margin-top: 0.8rem;
`;

export default ProjectsListing;
